<template>
  <div class="row">
    <!-- Production Card -->
    <div v-if="data.hasOwnProperty('production')" class="mb-4 col-12" :class="classObject">
      <div class="card border-left-primary shadow h-100 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <div v-else class="col mr-2">
              <div class="text-xs font-weight-bold text-primary text-uppercase mb-1">{{ $t('Production') }}</div>
              <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.production }} W</div>
            </div>
            <div class="col-auto">
              <img style="height: 62px; width:auto" src="https://shift2dc.prsma.com/public/assets/energy-icons/production.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Consumption Card -->
    <div v-if="data.hasOwnProperty('consumption')" class="mb-4 col-12" :class="classObject">
      <div class="card border-left-orange shadow h-100 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <div v-else class="col mr-2">
              <div class="text-xs font-weight-bold text-orange text-uppercase mb-1">{{ $t('Consumption') }}</div>
              <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.consumption.toLocaleString() }} W</div>
            </div>
            <div class="col-auto">
              <img style="height: 62px; width:auto" src="https://shift2dc.prsma.com/public/assets/energy-icons/consumption.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Wasting Card -->
    <div v-if="data.hasOwnProperty('wasting')" class="mb-4 col-12" :class="classObject">
      <div class="card border-left-info shadow h-100 py-2">
        <div class="card-body">
          <div class="row no-gutters align-items-center">
            <LoadingSpinner v-if="loading"></LoadingSpinner>
            <div v-else class="col mr-2">
              <div class="text-xs font-weight-bold text-info text-uppercase mb-1">{{ $t('Production_not_used') }}</div>
              <div class="h5 mb-0 font-weight-bold text-gray-800">{{ data.wasting }} W</div>
            </div>
            <div class="col-auto">
              <img style="height: 62px; width:auto" src="https://shift2dc.prsma.com/public/assets/energy-icons/production-not-used.png">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Battery Cards -->
    <div v-for="battery in data.batteries" :key="battery.deviceId" class="mb-4 col-12" :class="classObject">
        <div v-if="has_battery" >
        <!-- Battery Card -->
          <div class="card border-left-success shadow h-100 py-2">
            <div class="card-body">
              <div class="row no-gutters align-items-center">
                <LoadingSpinner v-if="loading"></LoadingSpinner>
                <div v-else class="col mr-2">
                  <div class="text-xs font-weight-bold text-success text-uppercase mb-1">
                    {{ $t('Battery_occupation') }} 
                    <h6 v-if="battery.name" class="d-inline"><span class="badge badge-success">{{ battery.name }}</span></h6>
                  </div>
                  <div v-if="battery.battery_level != null" class="row no-gutters align-items-center">
                    <div class="col-auto">
                      <div class="h5 mb-0 mr-3 font-weight-bold text-gray-800">{{ battery.battery_level }}%</div>
                    </div>
                    <div class="col d-md-none d-lg-block">
                      <div class="progress progress-sm mr-2">
                        <div class="progress-bar bg-success" role="progressbar" v-bind:style="{width: battery.battery_level+'%'}" :aria-valuenow="battery.battery_level" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                  </div>
                  <div v-else>
                    <span class="text-red">Erro na bateria</span>
                  </div>
                </div>
                <div class="col-auto text-center">
                  <img style="height: 62px; width:auto" src="https://shift2dc.prsma.com/public/assets/energy-icons/battery.png">
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>

    <!-- Battery Active Power Cards -->
    <div v-for="battery in batteries_active_power" :key="battery.deviceId" class="mb-4 col-12" :class="classObject">
      <div v-if="current_page == 'Substations'">
        <div class="card border-left-dark shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <LoadingSpinner v-if="loading"></LoadingSpinner>
              <div v-else class="col mr-2">
                <div class="text-xs font-weight-bold text-dark text-uppercase mb-1">
                  {{ $t('Active_power') }}
                  <h6 v-if="battery.name" class="d-inline"><span class="badge badge-dark">{{ battery.name }}</span></h6>
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">{{ (Math.round(battery.active_power * 100)/100).toLocaleString() }} kW</div>
              </div>
              <div class="col-auto text-center">
                <i class="fas fa-fw fa-bolt fa-3x" style="height:62px; width:auto; line-height:unset"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Battery Reactive Power Cards -->
    <div v-for="battery in batteries_reactive_power" :key="battery.deviceId" class="mb-4 col-12" :class="classObject">
      <div v-if="current_page == 'Substations'">
        <div class="card border-left-dark shadow h-100 py-2">
          <div class="card-body">
            <div class="row no-gutters align-items-center">
              <LoadingSpinner v-if="loading"></LoadingSpinner>
              <div v-else class="col mr-2">
                <div class="text-xs font-weight-bold text-dark text-uppercase mb-1">
                  {{ $t('Reactive_power') }}
                  <h6 v-if="battery.name" class="d-inline"><span class="badge badge-dark">{{ battery.name }}</span></h6>
                </div>
                <div class="h5 mb-0 font-weight-bold text-gray-800">
                  {{ (Math.round(battery.reactive_power * 100)/100).toLocaleString() }} kVAr
                </div>
              </div>
              <div class="col-auto">
                <i class="fas fa-fw fa-bolt fa-3x" style="height:62px; width:auto; line-height:unset"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'
export default {
  name: 'CurrentData',
  props: ['query'],
  components: {
    LoadingSpinner
  },
  data(){
    return {
      requestInterval: null,
      loading: false,
      group: {}
    }
  },
  mounted: function(){
    if (this.query.producerId && this.query.groupId) {
      this.create_interval()
      this.request_data()
    }
  },
  destroyed: function(){
    clearInterval(this.requestInterval)
  },
  methods: {
    create_interval: function(){
      const self = this
      if(this.requestInterval != null) clearInterval(this.requestInterval)
      let interval = 60000
      this.requestInterval = setInterval( () => { self.request_data() }, interval)
    },
    request_data: function(){
      this.loading = true
      this.$store.dispatch('getCurrentData', { query: this.query, batteries: this.group.bess }).then(() => { this.loading = false })
    },
  },
  watch:{
    query: function(){
      if (this.user_is_admin) this.group = this.$store.getters.remote_user_group(this.query.producerId, this.query.groupId)
      else this.group = this.$store.getters.user_group(this.query.groupId)
      this.create_interval()
      this.request_data()
    },
  },
  computed: {
    data: function(){
      const current_data = this.$store.getters.current_data
      if (!current_data.hasOwnProperty('batteries')) {
        current_data.batteries = []
      }

      return current_data
    },
    user_is_admin: function(){
      return this.$store.getters.user_isAdmin
    },
    has_battery: function(){
      if (this.$store.getters.user_isAdmin) return this.$store.getters.remote_user_bess
      else return this.$store.getters.user_bess
    }, 
    batteries: function(){
      if (this.group.bess && this.group.bess.length) return this.group.bess
      else return []
    },
    batteries_active_power: function() {
      let batteries = []
      if (this.data.hasOwnProperty("batteries"))
        this.data.batteries.forEach(b => {
          if (b.hasOwnProperty("last_sample") && b.last_sample) batteries.push({ name: b.name, active_power: b.last_sample.inverterActivePowerAggAvg })
        })
      return batteries
    },
    batteries_reactive_power: function() {
      let batteries = []
      if (this.data.hasOwnProperty("batteries"))
        this.data.batteries.forEach(b => {
          if (b.hasOwnProperty("last_sample") && b.last_sample && b.last_sample.inverterReactivePowerAggAvg != null) 
            batteries.push({ name: b.name, reactive_power: b.last_sample.inverterReactivePowerAggAvg || null})
        })
      return batteries
    },
    current_page: function(){
      return this.$route.name
    }, 
    classObject: function () {
      if (!this.batteries.length) return {
        'col-sm-4': true,
        'col-md-4': true,
        'col-lg-4': true,
        'col-xl-4': true,
      } 
      else return {
        'col-sm-4': true,
        'col-md-4': true,
        'col-lg-4': true,
        'col-xl-3': this.batteries.length == 1,
        'col-xl-4': this.batteries.length > 1 
      } 
    },
    classObjectBattery: function () {
      return {
        'col-sm-4': this.batteries.length == 3,
        'col-sm-6': this.batteries.length == 2,
        'col-sm-12': this.batteries.length == 1,
        'col-md-4': this.batteries.length == 3,
        'col-md-6': this.batteries.length == 2,
        'col-md-12': this.batteries.length == 1,
        'col-lg-4': this.batteries.length == 3,
        'col-lg-6': this.batteries.length == 2,
        'col-lg-12': this.batteries.length == 1,
        'col-xl-3': this.batteries.length == 1,
        'col-xl-4': this.batteries.length == 3,
        'col-xl-6': this.batteries.length == 2,
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.border-left-orange{
  border-left: .25rem solid #f7882f !important;
}
.text-orange {
  color: #f7882f!important;
}
.text-red {
  color: red
}
</style>
